import { supportServiceConnectClient } from "api";

import {
  ListAssetsRequest,
  ListAssetsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/assets/admin/v1/assets_pb";

import { RequestMetadata } from "api/types";

type ListAssetsParams = {
  orgId: string;
  pageToken?: string;
  pageSize: number;
  search?: string;
};

export const listAssets = async (
  { orgId, pageToken, pageSize, search }: ListAssetsParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListAssetsResponse> => {
  const req = new ListAssetsRequest({
    orgId,
    pageSize,
    search,
  });

  if (pageToken) {
    req.pageToken = pageToken;
  }

  return supportServiceConnectClient.listAssets(req, { headers });
};
